import type { ReportClaim } from '../../types/citation';
import { createRegistryResolver, tierSource } from './resolveCore';
import type { RegistryResolver, ResolverFactoryOptions } from './types';

export interface CitationResolverInput extends ResolverFactoryOptions {
  claims?: ReportClaim[];
  docSources?: Record<string, string[]>;
  llmSources?: Record<string, string[]>;
}

export function createCitationResolver(opts: CitationResolverInput): RegistryResolver {
  const fieldSources: Record<string, ReturnType<typeof tierSource>[]> = {};

  for (const [idx, claim] of (opts.claims ?? []).entries()) {
    const fieldKey = claim.sectionId ? `${claim.sectionId}:${idx}` : `claim:${idx}`;
    const tier1Sources = claim.sources.filter((s) => s.startsWith('doc:') || s.startsWith('provider:'));
    const tier = tier1Sources.length > 0 ? 1 : 3;
    fieldSources[fieldKey] = [
      tierSource(tier, claim.sources, {
        kind: tier === 1 ? 'document' : 'llm-inference',
        ref: `citation:${fieldKey}`,
        label: claim.text.slice(0, 60),
      }),
    ];
  }

  for (const [fieldKey, refs] of Object.entries(opts.docSources ?? {})) {
    fieldSources[fieldKey] = [
      tierSource(1, refs, {
        kind: 'document',
        ref: `citation:doc:${fieldKey}`,
        label: 'Document citations',
      }),
    ];
  }

  for (const [fieldKey, refs] of Object.entries(opts.llmSources ?? {})) {
    const sources = fieldSources[fieldKey] ?? [];
    sources.push(
      tierSource(3, refs, {
        kind: 'llm-inference',
        ref: `llm:citation:${fieldKey}`,
        label: 'LLM-only citations',
      }),
    );
    fieldSources[fieldKey] = sources;
  }

  return createRegistryResolver({
    registryId: 'citation',
    siteId: opts.siteId,
    fieldSources,
    now: opts.now,
  });
}
